/** The `viewControls` area: the controls at the head of a view: share, pin,
 *  root, display, show closed. Owned by the stage 2 slot components-a
 *  (docs/I18N.md §11). */
export const viewControls = {
  'viewControls.arrange': 'Arrange',
  /** An icon menu's name with its current choice beside it. */
  'viewControls.choice.withCurrent': '{label} ({current})',
  // The display flags and the closed-work footer.
  'viewControls.display.label': 'Display',
  'viewControls.display.labelClosedShown': 'Display (closed shown)',
  'viewControls.display.showClosed': 'Show closed',
  /** The checklist's "Lists" option: every member's own list open. */
  'viewControls.display.listsExpanded': 'Lists expanded',
  'viewControls.display.hideClosed': 'Hide closed',
  'viewControls.display.showClosedCount': {
    one: 'Show {count} closed',
    other: 'Show {count} closed',
  },
  // The star that pins a view to the sidebar.
  'viewControls.star.pin': 'Pin to the sidebar',
  'viewControls.star.unpin': 'Unpin from the sidebar',
  // The view's root item.
  'viewControls.root.set': 'Set root…',
  'viewControls.root.open': 'Open {title}',
  'viewControls.root.change': 'Change root…',
  'viewControls.root.clear': 'Clear root',
  /** The chip, when the viewer cannot see the root item's title. */
  'viewControls.root.chip': 'Root',
  'viewControls.root.label': 'Root item',
  'viewControls.root.subtitleBoard': "The board draws this item's sub-items, at any depth.",
  'viewControls.root.search': 'Search for the root item',
  // The share menu and the audience control.
  'viewControls.share.saveAsView': 'Save as board…',
  'viewControls.share.shareWork': 'Share the work…',
  'viewControls.share.audience': 'Audience…',
  'viewControls.share.audienceFor': 'Audience for {name}',
  'viewControls.share.onlyYou': 'Only you',
  'viewControls.share.actionsFor': 'Actions for {name}',
  'viewControls.share.copied': 'Copied',
  'viewControls.share.boardOptions': 'Board options',
  'viewControls.share.viewOptions': 'View options',
  'viewControls.share.share': 'Share',
  // The card menu on the overviews (/boards, /views): the acts about the
  // thing as a whole, then the ways out, each with its reach on the sub-line
  // and its explanation in the desktop tooltip.
  'viewControls.card.rename': 'Rename…',
  'viewControls.card.archive': 'Archive',
  'viewControls.card.archiveReach': 'For everyone',
  'viewControls.card.archiveTitleBoard':
    'Puts the board away for everyone who has it. It can be restored.',
  'viewControls.card.archiveTitleView':
    'Puts the view away for everyone who has it. It can be restored.',
  'viewControls.card.restore': 'Restore',
  'viewControls.card.leave': 'Leave',
  'viewControls.card.leaveReach': 'Only you',
  'viewControls.card.leaveTitleBoard': 'Takes you off the board. Nothing changes for anyone else.',
  'viewControls.card.leaveTitleView': 'Takes you off the view. Nothing changes for anyone else.',
  // The rename dialog.
  'viewControls.rename.titleBoard': 'Rename board',
  'viewControls.rename.titleView': 'Rename view',
  'viewControls.rename.name': 'Name',
  'viewControls.rename.save': 'Save',
  'viewControls.dialog.cancel': 'Cancel',
} as const;
